import { memo, useCallback } from "react";
import { ReactSVG, type Props as ReactSVGProps } from "react-svg";

interface CustomSvgIconProps extends Omit<ReactSVGProps, "ref"> {
  src: string;
  className?: string;
  isActive?: boolean;
  isDisabled?: boolean;
  isBlue?: boolean;
  width?: number | string;
  height?: number | string;
  beforeInjection?: (svg: SVGSVGElement) => void;
}

function CustomSvgIcon({
  src,
  className = "",
  isActive = false,
  isDisabled = false,
  isBlue = false,
  width,
  height,
  beforeInjection,
  ...restProps
}: CustomSvgIconProps) {
  const handleBeforeInjection = useCallback(
    (svg: SVGSVGElement) => {
      if (width !== undefined && width !== null) {
        svg.setAttribute("width", String(width));
      } else if (!svg.getAttribute("width")) {
        svg.setAttribute("width", "16");
      }

      if (height !== undefined && height !== null) {
        svg.setAttribute("height", String(height));
      } else if (!svg.getAttribute("height")) {
        svg.setAttribute("height", "16");
      }

      beforeInjection?.(svg);
    },
    [beforeInjection, height, width],
  );

  return (
    <ReactSVG
      src={src}
      className={`
        custom-svg-icon-wrapper
        cursor-pointer
        ${isActive ? "custom-active" : ""}
        ${isDisabled ? "custom-disabled" : ""}
        ${isBlue ? "blue-svg-icon" : "white-svg-icon"}
        ${className}
      `}
      beforeInjection={handleBeforeInjection}
      {...restProps}
    />
  );
}

export default memo(CustomSvgIcon);
